import { render, staticRenderFns } from "./Paystack.vue?vue&type=template&id=704878fa&"
import script from "./Paystack.vue?vue&type=script&lang=js&"
export * from "./Paystack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports